import { createTheme } from '@material-ui/core/styles';
import { theme as anuTheme } from '@anu/theme';
import withStyles from '@material-ui/core/styles/withStyles';

const headerFontFamily = '"Bitter", sans';

// Override default ANU LMS styles with a few things
// specific for MDC.
// Make the breakpoints match those from material base.
const theme = createTheme({
  ...anuTheme,
  typography: {
    ...anuTheme.typography,
    fontFamily: '"Source Sans 3", sans-serif;',
    h1: {
      ...anuTheme.typography.h1,
      fontFamily: headerFontFamily,
      fontSize: '2rem',
      lineHeight: '2.5rem',
      [anuTheme.breakpoints.up('md')]: {
        fontSize: '2.5rem',
        lineHeight: '3rem',
      },
    },
    h2: {
      ...anuTheme.typography.h2,
      fontFamily: headerFontFamily,
      fontSize: '1.5rem',
      lineHeight: '2rem',
      fontWeight: anuTheme.typography.fontWeightBold,
      [anuTheme.breakpoints.up('md')]: {
        fontSize: '2rem',
        lineHeight: '2.5rem',
      },
    },
    h3: {
      ...anuTheme.typography.h3,
      fontFamily: headerFontFamily,
      fontSize: '1.5rem',
      lineHeight: '2rem',
    },
    h4: {
      ...anuTheme.typography.h4,
      fontFamily: headerFontFamily,
      fontSize: '1.125rem',
      lineHeight: '1.5rem',
      fontWeight: anuTheme.typography.fontWeightBold,
      [anuTheme.breakpoints.up('md')]: {
        fontSize: '1.125rem',
        lineHeight: '1.5rem',
      },
    },
    h5: {
      ...anuTheme.typography.h5,
      fontFamily: headerFontFamily,
      fontSize: '1rem',
      lineHeight: '1.5rem',
      [anuTheme.breakpoints.up('md')]: {
        fontSize: '1rem',
      },
    },
    h6: {
      ...anuTheme.typography.h6,
      fontFamily: '"Source Sans 3", sans-serif;',
      fontSize: '1rem',
      lineHeight: '1.5rem',
      fontWeight: anuTheme.typography.fontWeightBold,
    },
    subtitle1: {
      ...anuTheme.typography.subtitle1,
      fontFamily: headerFontFamily,
      fontSize: '1rem',
      lineHeight: '1.5rem',
    },
    subtitle2: {
      ...anuTheme.typography.subtitle2,
      fontFamily: headerFontFamily,
      fontSize: '1rem',
      lineHeight: '1.5rem',
    },
    body1: {
      ...anuTheme.typography.body1,
      fontFamily: '"Source Sans 3", sans-serif;',
      lineHeight: '1.5rem',
    },
    body2: {
      ...anuTheme.typography.body2,
      fontFamily: '"Source Sans 3", sans-serif;',
    }
  },
  palette: {
    ...anuTheme.palette,
    common: {
      ...anuTheme.palette.common,
      black: '#1B1B1B',
      darkestBlue: '#162E51',
    },
    primary: {
      ...anuTheme.palette.primary,
      main: '#005EA2',
      dark: '#1A4480',
    },
    accent2: {
      main: '#005EA2',
    },
    success: {
      main: '#008817',
      contrastText: '#ffffff',
    },
    warning: {
      main: '#FEF0C8',
      contrastText: '#000000',
    },
    error: {
      main: '#B50909',
      contrastText: '#ffffff',
    },
    paragraphHighlight: {
      blue: '#E1F3F8',
      yellow: '#FEF0C8',
      green: '#ECF3EC',
      purple: '#F4E3FF',
    },
    link: {
      ...anuTheme,
      color: '#005EA2',
    },
  },
  breakpoints: {
    values: {
      xl: 1520,
      lg: 1200,
      md: 992,
      sm: 768,
      xs: 0,
    },
  },
  overrides: {
    MuiButton: {
      label: {
        whiteSpace: "nowrap",
        textTransform: "none",
      }
    },
    MuiSlider: {
      valueLabel: {
        // Change Slider pick color.
        "& > span": {
          backgroundColor: "#005EA2",
        }
      }
    },
    MuiTypography: {
      root: {
        // Change LessonNavigationItem component style.
        "&[data-menu-lesson-name]": {
          borderBottomWidth: "1px",
          borderBottomColor: '#005EA2',
        }
      }
    },
    MuiListItem: {
      root: {
        // Reduce list paddings.
        paddingTop: 1,
        paddingBottom: 1,

        // Remove coloring from list dots and numbers.
        "& > .MuiListItemIcon-root > span, &::marker": {
          color: anuTheme.palette.common.black,
        }
      },
    },
    MuiToggleButton: {
      root: {
        padding: '12px 16px',
        "&$selected": {
          backgroundColor: '#005EA2 !important',
          color: anuTheme.palette.common.white,
        }
      },
    },
  },
});

// Handle some global css overrides which exist
// outside of MUI components.
const GlobalCss = withStyles({
  '@global': {
    '#anu-application *': {
      boxSizing: 'border-box',
    },
    a: {
      color: theme.palette.primary.main,
      textDecoration: 'underline',
      '&:hover': {
        textDecoration: 'none',
      },
    },
    'strong.highlight': {
      background: '#FFFF00',
    },
    '[dir=rtl] #anu-application .MuiSvgIcon-root': {
      transform: 'scaleX(-1)',
    }
  },
})(() => null);

export { theme, GlobalCss };
